import { B as e, E as r } from "../separate-component-helper-chunks/exporting-BTf-uTZb.js";
import { C as o } from "../separate-component-helper-chunks/chart-area-BFNGdXa4.js";
import { N as m } from "../separate-component-helper-chunks/navigator-DHcKk6dH.js";
import { m as i } from "../separate-component-helper-chunks/mixin-DsSIi_3b.js";
const t = {
  beaconTagName: "beacon-line-chart"
}, a = class a extends i(e).with(
  o,
  m,
  r
) {
  constructor() {
    super(...arguments), this.beaconTagName = t.beaconTagName;
  }
  static get styles() {
    return [super.styles, this.chartAreaStyles, this.navigatorStyles];
  }
};
a.tagName = t.beaconTagName;
let s = a;
export {
  s as BeaconLineChart
};
